import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { bcg, title, redirectLink } from './ErrorBoundary.module.css';
import { CONTACT_US_LINK } from '../../utils/constants';
import { imgUrlGenerate } from '../../helpers';
import { element } from 'prop-types';

export default class ErrorBoundary extends Component {
  static propTypes = {
    children: element
  }

  state = {
    hasError: false
  }

  componentDidCatch() {
    this.setState({ hasError: true })
  }

  render() {
    const { hasError } = this.state
    const { children } = this.props

    if (hasError) {
      return (
        <div className={`${bcg}`}>
          <h1 className={`title-big ${title}`}>
            An error occurred on page loading.
              <br />
            Please refresh the page or try to visit it later.
          </h1>
          <Link to={`/${CONTACT_US_LINK}/`} className={redirectLink}>
            Go Back
          <img src={imgUrlGenerate(`go_back-arrow.svg`)} alt='Go back' />
          </Link>
        </div>
      )
    }
    return children
  }
}